<template>
  <b-dropdown block :variant="buttonVariant" class="status-control">
    <template #button-content>
      <b-spinner v-if="isBusy" small class="align-middle"></b-spinner>
      {{ statusTitle }}
    </template>

    <b-dropdown-item @click="onClick(statuses.CHECKED)" :disabled="isDisabled || value === statuses.CHECKED">
      {{ statusTitles[statuses.CHECKED] }}
    </b-dropdown-item>
    <b-dropdown-item @click="onClick(statuses.UNCHECKED)" :disabled="isDisabled || value === statuses.UNCHECKED">
      {{ statusTitles[statuses.UNCHECKED] }}
    </b-dropdown-item>
    <b-dropdown-item @click="onClick(statuses.UNKNOWN)" :disabled="isDisabled || !value || value === statuses.UNKNOWN">
      {{ statusTitles[statuses.UNKNOWN] }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import constants from '@/constants';

export default {
  name: 'CodeOfConductStatusControl',

  props: {
    value: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    const statuses = constants.companyFiles.codeOfConductStatuses;
    return {
      statuses,
      statusTitles: {
        [statuses.CHECKED]: this.$t(`codeOfConduct.${statuses.CHECKED}`),
        [statuses.UNCHECKED]: this.$t(`codeOfConduct.${statuses.UNCHECKED}`),
        [statuses.UNKNOWN]: this.$t(`codeOfConduct.${statuses.UNKNOWN}`),
      },
      statusClasses: {
        [statuses.CHECKED]: 'file-status-approved',
        [statuses.UNCHECKED]: 'file-status-wrong',
        [statuses.UNKNOWN]: 'file-status-not-loaded',
      },
    };
  },

  computed: {
    isDisabled() {
      return this.disabled || this.isBusy;
    },

    statusTitle() {
      return this.statusTitles[this.value] || this.statusTitles[this.statuses.UNKNOWN];
    },

    buttonVariant() {
      return this.statusClasses[this.value] || this.statusClasses[this.statuses.UNKNOWN];
    },
  },

  methods: {
    onClick(status) {
      this.$emit('input', status);
    },
  },
};
</script>

<style scoped>
.status-control >>> .btn {
  border-radius: 1.25rem;
  box-shadow: 0px 3px 6px 0px #97979752;
  min-width: 100%;
  color: black;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/organisation/EditCompany/CodeOfConductStatusControl.vue